import { Bullet } from "devextreme-react";
import { Font, Margin, Size, Tooltip } from "devextreme-react/bullet";

function customizeTooltip(arg) {
  return {
    text: `Current Work Time: ${arg.value}<br/>Target Time: ${arg.target}`,
  };
}

const ScheduleVarianceCell = (cellData) => {
  console.debug("cellData", cellData);

  return (
    <Bullet
      showTarget={true}
      showZeroLevel={false}
      value={cellData.data.workTime}
      target={cellData.data.time}
      color={cellData.value >= 0 ? "#009688" : "#e55253"}
      //   startScaleValue={0}
      //   endScaleValue={100}
    >
      <Size width={150} height={35} />
      <Margin top={5} bottom={0} left={5} />
      <Tooltip
        enabled={true}
        paddingTopBottom={2}
        zIndex={5}
        customizeTooltip={customizeTooltip}
      >
        {/* <Font size={18} /> */}
      </Tooltip>
    </Bullet>
  );
};

export default ScheduleVarianceCell;
